// extracted by mini-css-extract-plugin
module.exports = {"container__wrapperTodo":"Main_container__wrapperTodo__1GTB6","wrapperTodo":"Main_wrapperTodo__2iYPM"};